export const environment = {
    production: false,
    baseUrl: 'https://api-stage.marketplace.alphatrend.ai',
    referalUrl: 'https://stage.okstatetokens.com'
};
